export class CustomerSource {
    name = null;
    code = null;
    isUsing = true;
    positions = [];
}